/**
 * Cash Medical Support Rates
 * 
 * Data exported from [calc].cash_medical_support table
 * Note: This appears to be year-agnostic in the Ruby codebase
 * 
 * Structure:
 * - minimumIncome: Minimum net monthly income for this bracket
 * - maximumIncome: Maximum net monthly income for this bracket
 * - rates: Array of percentage rates as decimals (e.g., 0.02 = 2%) for 1-5 children
 * - cashMedicalSupport: Whether cash medical support applies for this bracket
 * 
 * Status mapping:
 * - status_lookup_id: 0 -> 1000 (active), 1 -> 99 (inactive)
 * - Only export records where status_lookup_id = 1000 (active)
 */

import { CashMedicalSupportLevel } from '../../../types';

export const cashMedicalSupportLevelsIA2021: CashMedicalSupportLevel[] = [
  {
    minimumIncomeAmount: 0,
    maximumIncomeAmount: 1150.99,
    rates: [0.0, 0.0, 0.0, 0.0, 0.0],
    isCashMedicalSupport: false
  },
  {
    minimumIncomeAmount: 1151,
    maximumIncomeAmount: 1200.99,
    rates: [0.02, 0.02, 0.01, 0.01, 0.01],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1201,
    maximumIncomeAmount: 1250.99,
    rates: [0.02, 0.02, 0.02, 0.01, 0.01],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1251,
    maximumIncomeAmount: 1300.99,
    rates: [0.03, 0.02, 0.02, 0.02, 0.01],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1301,
    maximumIncomeAmount: 1350.99,
    rates: [0.03, 0.02, 0.02, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1351,
    maximumIncomeAmount: 1400.99,
    rates: [0.03, 0.02, 0.02, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1401,
    maximumIncomeAmount: 1450.99,
    rates: [0.04, 0.02, 0.02, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1451,
    maximumIncomeAmount: 1500.99,
    rates: [0.04, 0.03, 0.02, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1501,
    maximumIncomeAmount: 1550.99,
    rates: [0.04, 0.03, 0.02, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1551,
    maximumIncomeAmount: 1600.99,
    rates: [0.05, 0.03, 0.03, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1601,
    maximumIncomeAmount: 1650.99,
    rates: [0.05, 0.03, 0.03, 0.02, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1651,
    maximumIncomeAmount: 1700.99,
    rates: [0.05, 0.03, 0.03, 0.03, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1701,
    maximumIncomeAmount: 1750.99,
    rates: [0.05, 0.04, 0.03, 0.03, 0.02],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1751,
    maximumIncomeAmount: 1800.99,
    rates: [0.05, 0.04, 0.03, 0.03, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1801,
    maximumIncomeAmount: 1850.99,
    rates: [0.05, 0.04, 0.03, 0.03, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1851,
    maximumIncomeAmount: 1900.99,
    rates: [0.05, 0.04, 0.03, 0.03, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1901,
    maximumIncomeAmount: 1950.99,
    rates: [0.05, 0.04, 0.04, 0.03, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 1951,
    maximumIncomeAmount: 2000.99,
    rates: [0.05, 0.04, 0.04, 0.03, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2001,
    maximumIncomeAmount: 2050.99,
    rates: [0.05, 0.05, 0.04, 0.03, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2051,
    maximumIncomeAmount: 2100.99,
    rates: [0.05, 0.05, 0.04, 0.04, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2101,
    maximumIncomeAmount: 2150.99,
    rates: [0.05, 0.05, 0.04, 0.04, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2151,
    maximumIncomeAmount: 2200.99,
    rates: [0.05, 0.05, 0.04, 0.04, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2201,
    maximumIncomeAmount: 2250.99,
    rates: [0.05, 0.05, 0.04, 0.04, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2251,
    maximumIncomeAmount: 2300.99,
    rates: [0.05, 0.05, 0.05, 0.04, 0.03],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2301,
    maximumIncomeAmount: 2350.99,
    rates: [0.05, 0.05, 0.05, 0.04, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2351,
    maximumIncomeAmount: 2400.99,
    rates: [0.05, 0.05, 0.05, 0.04, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2401,
    maximumIncomeAmount: 2450.99,
    rates: [0.05, 0.05, 0.05, 0.05, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2451,
    maximumIncomeAmount: 2500.99,
    rates: [0.05, 0.05, 0.05, 0.05, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2501,
    maximumIncomeAmount: 2550.99,
    rates: [0.05, 0.05, 0.05, 0.05, 0.04],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2551,
    maximumIncomeAmount: 2600.99,
    rates: [0.05, 0.05, 0.05, 0.05, 0.05],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2601,
    maximumIncomeAmount: 2650.99,
    rates: [0.05, 0.05, 0.05, 0.05, 0.05],
    isCashMedicalSupport: true
  },
  {
    minimumIncomeAmount: 2651,
    maximumIncomeAmount: 25000.99,
    rates: [0.05, 0.05, 0.05, 0.05, 0.05],
    isCashMedicalSupport: true
  }
];
